// Path: src\Components\Contest\ContestDetail.jsx
import { React, useEffect, useState } from "react";
import sharewithfriendicon from "../../../images/sharewithfriendicon.png";
import kills from "../../../images/kills.png";
import userimg from "../../../images/user.png";
import ranksimg from "../../../images/ranks.png";
import Coin from "../../../images/coin.png"
import { contestDetails, contestJoinedUserDetails } from "../../../api/contest.api";
import { formatDate, formatTime, shareLink } from "../../../Utilities/helper";
import { url } from "../../../config/url";
import { useNavigate } from "react-router";
import ListLoader from "../../Common/ListLoader";
import { toastInfo } from "../../../Utilities/toast";
import { t } from "i18next";
import moment from "moment";
import WinningBreakup from "../../Popup/WinningPopup";
import { RWebShare } from "react-web-share";
import premiumicon from "../../../images/premium.png";

const ContestDetailTab = ({
  contestId,
  setContestDetailsData,
  setPricePointPool,
  setWinningBrarkupContest,
  setDetailsWinning,
}) => {
  const profile = JSON?.parse(localStorage.getItem("profile"));
  const navigate = useNavigate();
  const [joinedPlayers, setJoinedPlayer] = useState(0);
  const [totalPlayers, setTotalPlayer] = useState(0);
  const [percentage, setPercentage] = useState(
    (joinedPlayers / totalPlayers) * 100
  );
  const [details, setDetails] = useState(null);
  const [player, setPlayerDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(details?.shortCode)
      .then(() => {
        toastInfo("short code copied");
      })
      .catch((err) => {});
  };
  const handleCopyPassword = () => {
    toastInfo("Room Password Copied");
    navigator.clipboard.writeText(details?.password).catch((err) => {});
  };
  const handleCopyID = () => {
    toastInfo("Room ID Copied");
    navigator.clipboard.writeText(details?.roomId).catch((err) => {});
  };
  useEffect(() => {
    fetchContestDetails();
  }, []);
  const fetchContestDetails = async () => {
    setLoading(true);
    try {
      const res = await contestDetails(contestId);
      if (res?.success && res?.data) {
        setContestDetailsData(res?.data);
        setDetails(res?.data);
        setTotalPlayer(res?.data?.totalPlayers);
        setJoinedPlayer(res?.data?.totalJoinedPlayers);
        setPercentage(
          ((res?.data?.totalJoinedPlayers || 0) /
            (res?.data?.totalPlayers || 0)) *
            100
        );
        await fetchContestJoinedUser();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const fetchContestJoinedUser = async () => {
    try {
      setLoading(true);
      const res = await contestJoinedUserDetails(contestId, {
        search: { user: profile?.user_id },
      });
      if (res?.success && res?.captainData) {
        setPlayerDetails(res?.captainData);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const showWinningBreakup = (contestId) => {
    if (contestId) {
      let detailInfo = { ...details };
      if (detailInfo?.contestFor?.[0]) {
        detailInfo.currency = [];
        if (detailInfo?.contestFor?.[0]?.inCurrencyInfo) {
          detailInfo.currency[0] = {
            inCurrency: {},
          };
          detailInfo.currency[0].inCurrency =
            detailInfo?.contestFor?.[0]?.inCurrencyInfo;
        }
        if (detailInfo?.contestFor?.[0]?.outCurrencyInfo) {
          detailInfo.currency[0] = {
            outCurrency: {},
          };
          detailInfo.currency[0].outCurrency =
            detailInfo?.contestFor?.[0]?.outCurrencyInfo;
        }
      }
      setDetailsWinning(detailInfo);
      setWinningBrarkupContest(contestId);
      setPricePointPool(true);
    } else {
      setWinningBrarkupContest(null);
      setPricePointPool(false);
    }
  };

  return (
    <>
      {details && (
        <div className="tournamentround-detail-container">
          <div className="container tournament-card--wrap mt-4">
            <div className="tournament-card mb-4">
              <div className="card-body d-flex flex-column justify-content-between">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="card-title">
                  {details?.title?.length > 25 ? (
                        <marquee> {details?.title}</marquee>
                      ) : (
                        details?.title
                      )}
                    {/* {details?.title} */}
                    </div>
                  <button
                    className="btn rules-btn"
                    style={{ width: "fit-content" }}
                    onClick={handleCopy}
                  >
                    ID-{details?.shortCode}
                  </button>
                </div>
                <hr style={{margin:"0.5rem 0"}}></hr>
                <div className="row">
                  <div className="col-12">
                    <div className="tournament-card-detail">
                      <div className="row">
                        {/* First row (date, round, ID) */}
                        <div className="col-12 tournament-card-box--wrap">
                          <div className="row">
                            <div className="col-3 tournament-card-box">
                              <div className="detail-item">
                                <div className="tournament-detail-label letter-spacing">
                                  {/* {details?.date.length > 7 ? (
                                    <marquee>
                                      {formatDate(details?.date)}
                                    </marquee>
                                  ) : (
                                    formatDate(details?.date)
                                  )} */}
                                  {formatDate(details?.date)}
                                </div>
                                <div className="tournament-detail-value">
                                  date
                                </div>
                              </div>
                            </div>
                            <div className="col-3 tournament-card-box">
                              <div className="detail-item">
                                <div className="tournament-detail-label">
                                {/* {details?.time.length > 6 ? (
                                    <marquee>
                                      {moment(details?.time).format('hh:mm A')}
                                    </marquee>
                                  ) : (
                                    moment(details?.time).format('hh:mm A')
                                  )} */}
                                {moment(details?.time).format('hh:mm A')}
                                </div>
                                <div className="tournament-detail-value">
                                  time
                                </div>
                              </div>
                            </div>
                            {details?.titles?.[0]?.isSelection &&
                              details?.titles?.[0]?.name &&
                              details?.titles?.[0]?.value && (
                                <div className="col-3 tournament-card-box">
                                  <div className="detail-item">
                                    <div className="tournament-detail-label">
                                    {/* {details?.titles?.[0]?.value.length > 6 ? (
                                    <marquee>
                                       {details?.titles?.[0]?.value}
                                    </marquee>
                                  ) : (
                                    details?.titles?.[0]?.value
                                  )} */}
                                   {details?.titles?.[0]?.value}
                                    </div>
                                    <div className="tournament-detail-value">
                                    {/* {details?.titles?.[0]?.name.length > 6 ? (
                                    <marquee>
                                       {details?.titles?.[0]?.name}
                                    </marquee>
                                  ) : (
                                    details?.titles?.[0]?.name
                                  )} */}
                                      {details?.titles?.[0]?.name}
                                    </div>
                                  </div>
                                </div>
                              )}
                            {details?.titles?.[1]?.isSelection &&
                              details?.titles?.[1]?.name &&
                              details?.titles?.[1]?.value && (
                                <div className="col-3 tournament-card-box">
                                  <div className="detail-item">
                                    <div className="tournament-detail-label">
                                       {/* {details?.titles?.[1]?.value.length > 6 ? (
                                    <marquee>
                                       {details?.titles?.[1]?.value}
                                    </marquee>
                                  ) : (
                                    details?.titles?.[1]?.value
                                  )} */}
                                      {details?.titles?.[1]?.value}
                                    </div>
                                    <div className="tournament-detail-value">
                                    {/* {details?.titles?.[1]?.name.length > 6 ? (
                                    <marquee>
                                       {details?.titles?.[1]?.name}
                                    </marquee>
                                  ) : (
                                    details?.titles?.[1]?.name
                                  )} */}
                                      {details?.titles?.[1]?.name}
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-2">
                  <div className="tournament-details-winnings tournament-details-winnings-1">
                    <div className="d-flex justify-content-between">
                      <p className="prize-info">
                        prize pool
                        <span className="tournament-prizepool">
                          {details?.prizePool}
                          <img
                            className="currency-icon"
                            src={
                              url?.IMAGE_URL +
                              details?.contestFor[0]?.outCurrencyInfo?.img
                                ?.default
                            }
                          />

                          {/* <img
                                        className="currency-icon"
                                        src={Diamond}
                                        alt=""
                                    /> */}
                        </span>
                      </p>
                      <p className="prize-info">
                        {details?.winningModel == "perKill"
                          ? "per Kill"
                          : "winners"}
                        <span className="tournament-prizepool">
                          {details?.winningModel === "perKill"
                            ? details?.killPoints
                            : details?.totalWinners}
                            {details?.winningModel === "perKill"&&
                              <img
                            className="currency-icon"
                            src={
                              url?.IMAGE_URL +
                              details?.contestFor[0]?.outCurrencyInfo?.img
                                ?.default
                            }
                          />
}                          {details?.winningModel != "perKill" && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="tournament-arrow-icon"
                              viewBox="0 0 20 20"
                              onClick={() => showWinningBreakup(details?._id)}
                              style={{ cursor: "pointer" }} // Optional: Add
                            >
                              <path d="M5.83288 8.33326L9.99956 12.4999L14.16622 8.33326" />
                            </svg>
                          )}
                        </span>
                      </p>
                      <p className="join-using join-using-1" style={{color:"#d5d6d9"}}>
                         join using{" "}
                        {details?.entryFee > 0 ? (
                          <>
                           
                            <span className="tournament-prizepool">
                              {details?.entryFee}
                              <img
                                className="currency-icon"
                                src={
                                  url?.IMAGE_URL +
                                  details?.contestFor[0]?.inCurrencyInfo?.img
                                    ?.default
                                }
                                alt=""
                              />
                            </span>
                          </>
                        ) : (
                          <span className="font-weight-bold text-white">free</span>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-2">
                  {/* Progress Bar */}
                  <div
                    className="progress"
                    style={{ height: "6px", width: "100%" }}
                  >
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${percentage}%`,
                        backgroundColor: "#9F6693",
                      }}
                      aria-valuenow={joinedPlayers}
                      aria-valuemin="0"
                      aria-valuemax={totalPlayers}
                    ></div>
                  </div>
                </div>

                <p className="progressbar-text mt-2 mb-0">
                  <div>
                    {details?.totalJoinedPlayers}{" "}
                    {details?.totalJoinedPlayers > 1 ? "players" : "player"}{" "}
                    joined
                  </div>
                  <div>{details?.totalPlayers}</div>
                </p>
                <div className="d-flex justify-content-between align-items-center tournament-copied-detail--wrap mt-1">
                  <div className="tournament-copied-detaild d-block">
                  {details?.roomId !== "" ? (
                      <>
                        <span className="tournament-details-roomid-value">
                          {" "}
                          {details?.roomId}{" "}
                        </span>{" "}
                        <span
                          className="tournament-detail-svg"
                          onClick={handleCopyID}
                          style={{ cursor: "pointer" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9"
                            height="10"
                            viewBox="0 0 9 10"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_2738_2557)">
                              <path
                                d="M8.8965 1.965L7.0515 0.1C6.9885 0.035 6.8985 0 6.8085 0H3.114C2.412 0 1.845 0.575 1.845 1.28V1.86H1.269C0.567 1.86 0 2.435 0 3.14V8.72C0 9.425 0.5715 10 1.269 10H5.886C6.588 10 7.155 9.425 7.155 8.72V8.14H7.731C8.433 8.14 9 7.565 9 6.86V2.21C9 2.12 8.964 2.03 8.8965 1.965ZM7.155 1.19L7.821 1.86H7.155V1.19ZM6.462 8.72C6.462 9.04 6.2055 9.3 5.886 9.3H1.269C0.9495 9.3 0.693 9.04 0.693 8.72V3.14C0.693 2.82 0.9495 2.56 1.269 2.56H1.845V6.86C1.845 7.565 2.4165 8.14 3.114 8.14H6.462V8.72ZM7.731 7.44H3.114C2.7945 7.44 2.538 7.18 2.538 6.86V1.28C2.538 0.96 2.7945 0.7 3.114 0.7H6.462V2.21C6.462 2.405 6.615 2.56 6.8085 2.56H8.307V6.86C8.307 7.18 8.0505 7.44 7.731 7.44Z"
                                fill="white"
                              />
                              <path
                                d="M6.80834 5.57996H4.04084C3.85184 5.57996 3.69434 5.73496 3.69434 5.92996C3.69434 6.12496 3.84734 6.27996 4.04084 6.27996H6.80834C6.99734 6.27996 7.15484 6.12496 7.15484 5.92996C7.15484 5.73496 7.00184 5.57996 6.80834 5.57996Z"
                                fill="white"
                              />
                              <path
                                d="M6.80834 3.71997H4.04084C3.85184 3.71997 3.69434 3.87497 3.69434 4.06997C3.69434 4.26497 3.84734 4.41997 4.04084 4.41997H6.80834C6.99734 4.41997 7.15484 4.26497 7.15484 4.06997C7.15484 3.87497 7.00184 3.71997 6.80834 3.71997Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_2738_2557">
                                <rect width="9" height="10" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </>
                    ) : (
                      "-"
                    )}
                    <div className="tournament-details-roomid-lable">
                      room id
                    </div>{" "}
                  
                  </div>
                  <div className="tournament-copied-detaild d-block">
                    <div className="d-flex justify-content-end align-items-center">
                    {details?.roomPassword !== "" ? (
                      <>
                        <span className="tournament-details-roomid-value">
                          {" "}
                          {details?.roomPassword}{" "}
                        </span>{" "}
                        <span
                          className="tournament-detail-svg ms-1"
                          onClick={handleCopyPassword}
                          style={{ cursor: "pointer" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="9"
                            height="10"
                            viewBox="0 0 9 10"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_2738_2557)">
                              <path
                                d="M8.8965 1.965L7.0515 0.1C6.9885 0.035 6.8985 0 6.8085 0H3.114C2.412 0 1.845 0.575 1.845 1.28V1.86H1.269C0.567 1.86 0 2.435 0 3.14V8.72C0 9.425 0.5715 10 1.269 10H5.886C6.588 10 7.155 9.425 7.155 8.72V8.14H7.731C8.433 8.14 9 7.565 9 6.86V2.21C9 2.12 8.964 2.03 8.8965 1.965ZM7.155 1.19L7.821 1.86H7.155V1.19ZM6.462 8.72C6.462 9.04 6.2055 9.3 5.886 9.3H1.269C0.9495 9.3 0.693 9.04 0.693 8.72V3.14C0.693 2.82 0.9495 2.56 1.269 2.56H1.845V6.86C1.845 7.565 2.4165 8.14 3.114 8.14H6.462V8.72ZM7.731 7.44H3.114C2.7945 7.44 2.538 7.18 2.538 6.86V1.28C2.538 0.96 2.7945 0.7 3.114 0.7H6.462V2.21C6.462 2.405 6.615 2.56 6.8085 2.56H8.307V6.86C8.307 7.18 8.0505 7.44 7.731 7.44Z"
                                fill="white"
                              />
                              <path
                                d="M6.80834 5.57996H4.04084C3.85184 5.57996 3.69434 5.73496 3.69434 5.92996C3.69434 6.12496 3.84734 6.27996 4.04084 6.27996H6.80834C6.99734 6.27996 7.15484 6.12496 7.15484 5.92996C7.15484 5.73496 7.00184 5.57996 6.80834 5.57996Z"
                                fill="white"
                              />
                              <path
                                d="M6.80834 3.71997H4.04084C3.85184 3.71997 3.69434 3.87497 3.69434 4.06997C3.69434 4.26497 3.84734 4.41997 4.04084 4.41997H6.80834C6.99734 4.41997 7.15484 4.26497 7.15484 4.06997C7.15484 3.87497 7.00184 3.71997 6.80834 3.71997Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_2738_2557">
                                <rect width="9" height="10" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </>
                    ) : (
                      "-"
                    )}
                    </div>
                    <div className="tournament-details-roomid-lable">
                      password
                    </div>{" "}
                 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {player && (
        <div className="tournament-detail-playertable">
          <div className="player-header row">
            <div className="player-header-item--user col-3">
              <div className="player-header-item">
                <img className="players-table-img" src={userimg} style={{margin:"0"}}></img>
                username
              </div>
            </div>
            <div className="player-header-item--user-detail col-5">
              <div className="row w-100">
                <div className="player-header-item col-6">
                  <img className="players-table-img" src={kills} style={{margin:"0"}}></img> kills
                </div>
                <div className="player-header-item col-6">
                  <img className="players-table-img" src={ranksimg}></img> ranks
                </div>
              </div>
            </div>
          </div>

          {player ? (
            <>
              {/* onClick={() => navigate('/user-profile/' + player?._id)}   redirect link but captain not redirect */}
              <div className="player-row row" key={player._id}>
                <div className="player-header-item--user col-3">
                  <div className="player-row-item player-row-item-1">
                    <span className="player-info-1">
                      {player?.gamerjiName.length > 15 ? (
                        <marquee>{player?.gamerjiName}</marquee>
                      ) : (
                        player?.gamerjiName
                      )}
                        {player?.isPremium ? (
                        <img
                          className="players-table-img"
                          src={premiumicon}
                          alt="Premium Icon"
                        />
                      ) : (
                        ""
                      )}
                      {/* {player?.gamerjiName} */}
                    </span>
                  </div>
                </div>
                <div className="player-header-item--user-detail col-5">
                  <div className="row w-100">
                    <div className="player-row-item col-6">
                      <span>{player?.kills === 0 ? "-" : player?.kills}</span>
                    </div>
                    <div className="player-row-item col-6">
                      <span>{player?.rank === 0 ? "-" : player?.rank}</span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      )}

        {(details == null && !loading) && <div className='w-100 d-flex justify-content-center no-record-found-center'><span className="text-center">{t('common.no_data_found')}</span></div>}
        {loading && <div className='w-100 d-flex justify-content-center no-record-found-center'> <ListLoader /></div>}
        {details && 
            <RWebShare
            data={shareLink(details?.shortCode)}
            sites={["facebook", "twitter", "whatsapp", "linkedin", "copy"]}
            onClick={() => { console.log("shared successfully!") }}>
                <button className="d-flex justify-content-center submit-button mt-5 mb-4">
                    <span><img className="sharewithfriendscontesttournament-img" src={sharewithfriendicon} alt=""></img></span>
                    <div className="sharewithfriendscontesttournament-text">Share with friends</div>
                </button>
            </RWebShare>
        }
        <div>

      </div>
    </>)
}
export default ContestDetailTab;
